import * as React from 'react';

import { Accordion, cn, Row } from '@rematter/ui-web';
import { LucideBrain, LucideChevronDown } from 'lucide-react';

import { useTranslations } from '../../i18n/useTranslations';

import { config } from '~/config';

interface ThinkingDisplayProps {
  thinking: string;
}

//
// ⚛️ ⚛️ ⚛️ THINKING DISPLAY ⚛️ ⚛️ ⚛️
//
export const ThinkingDisplay = ({ thinking }: ThinkingDisplayProps) => {
  // Translations
  const t = useTranslations();

  // State
  const [isExpanded, setIsExpanded] = React.useState(false);

  const isProduction = config.environment === 'production';

  if (!thinking) {
    return null;
  }

  return (
    <Accordion
      className={cn(
        '@ThinkingDisplay',
        'rounded-md bg-primary/5 text-sm text-primary',
        '[&_button]:hover:bg-primary/5',
        '[&_button]:py-2',
      )}
      variant="ghost"
      size="sm"
      isExpanded={isExpanded}
      onExpandedChange={setIsExpanded}
      isDisabled={isProduction}
      hideIcon={isProduction}
      icon={
        <LucideChevronDown
          size={16}
          className="shrink-0 group-data-[expanded]:scale-[-1]"
        />
      }
      trigger={
        <Row gap2 className="items-center">
          <LucideBrain size={16} />
          <span>{t.chat.thinking}</span>
        </Row>
      }
    >
      {isExpanded && (
        <div className="pl-6">
          <pre className="overflow-auto rounded bg-neutral/10 p-2 font-mono text-xs whitespace-pre-wrap text-foreground">
            {thinking}
          </pre>
        </div>
      )}
    </Accordion>
  );
};
